import { useSelector } from 'react-redux';

import { useExperimentsTranslations } from 'modules/experiments/hooks';
import {
  getCampaignMessageMedium,
  getExperimentHeaderMetadata,
  getExperimentId,
} from 'modules/experiments/ducks/selectors';
import { ExperimentName } from 'modules/experiments/components/ui';

import { spacing } from 'ui/theme';

import { MonitorPageActions } from './MonitorPageActions';
import { ExperimentDetails } from './ExperimentDetails';
import { ExperimentHeader, StyledSecondaryPageHeader } from './Styled';

export const PageHeader = () => {
  const { t } = useExperimentsTranslations();

  const breadcrumb = {
    content: t('monitor.header.breadcrumb'),
    href: '/experiments',
  };

  // Redux Selector
  const { name, experimentState } = useSelector(getExperimentHeaderMetadata);
  const messageMedium = useSelector(getCampaignMessageMedium);
  const id = useSelector(getExperimentId);

  // If data hasn't been fetched yet
  if (!name || !experimentState) return null;

  return (
    <StyledSecondaryPageHeader
      documentTitle={`${name} | Experiments`}
      data-test="experiments-monitor-header"
      breadcrumb={breadcrumb}
      widthStyle={spacing.PageWidthStyle.normal}
      pageSubSection={<ExperimentDetails />}
      pageActions={<MonitorPageActions />}
    >
      <ExperimentHeader>
        <ExperimentName id={id} name={name} messageMedium={messageMedium} />
      </ExperimentHeader>
    </StyledSecondaryPageHeader>
  );
};
